import { Navigate } from "react-router-dom";
import FullLayout from "../layouts/FullLayout/FullLayout.js";
import Complaint_stats from "../views/dashboards/Complaint_stats";
import UserForm from "../views/FormLayouts/fb-elements/UserForm.js";
import ForgotPassword from "../views/login_form/ForgotPassword.js";
import ResetPassword from "../views/login_form/ResetPassword.js";
import Dashboard1 from "../views/dashboards/Dashboard1.js";
import Complaints from "../views/dashboards/ComplaintStatus.js";
import Print from "../views/dashboards/Print.js";
import FormLayouts from "../views/FormLayouts/FormLayouts.js";
import Login from "../views/login_form/login.js";

const ThemeRoutes = [
  {
    path: "/workorder",
    element: <FullLayout />,
    children: [
      { path: "/workorder", element: <Navigate to="/workorder/wof/login" /> }, // Default redirect
      { path: "/workorder/wof/stats", element: <Complaint_stats /> },
      { path: "/workorder/wof/dashboard", element: <Dashboard1 /> },
      { path: "/workorder/wof/complaints", element: <Complaints /> },
      { path: "/workorder/wof/form-layouts/input-form", element: <FormLayouts /> },
      { path: "/workorder/wof/form-elements/login", element: <Login /> },
      { path: "/workorder/wof/print-Technician", element: <Print /> },
      { path: "/workorder/wof/dashboard-Admin", element: <Dashboard1 /> },
      { path: "/workorder/wof/UserForm", element: <UserForm /> },
    ],
  },
  {
    path: "/workorder/wof/login",
    children: [
      { path: "", exact: true, element: <Login /> },
      { path: "/workorder/wof/login/forgot-password", element: <ForgotPassword /> },
      { path: "/workorder/wof/login/reset-password", element: <ResetPassword /> },
    ],
  },
];

export default ThemeRoutes;
